"use client";

/**
 * Last-resort error boundary. Renders its own <html>/<body> because the root
 * layout itself failed. Keep it dependency-free.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          padding: "6rem 1.5rem",
          fontFamily:
            "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
          background: "#FAF8F4",
          color: "#1A1A1A",
        }}
      >
        <div style={{ maxWidth: 640, margin: "0 auto" }}>
          <h1 style={{ fontSize: "1.75rem", margin: 0 }}>
            Something broke on our end.
          </h1>
          <p style={{ marginTop: "1rem", color: "#555" }}>
            We logged it. Refresh the page or try again in a few minutes.
          </p>
          <button
            type="button"
            onClick={() => reset()}
            style={{
              marginTop: "2rem",
              padding: "0.75rem 1.25rem",
              background: "#01696F",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
              fontSize: "1rem",
            }}
          >
            Try again
          </button>
          {error.digest ? (
            <p style={{ marginTop: "2rem", color: "#999", fontSize: "0.85rem" }}>
              Error reference: {error.digest}
            </p>
          ) : null}
        </div>
      </body>
    </html>
  );
}
